export function hasValue(value: any): boolean {
  return value !== null && value !== undefined;
}
